module.exports = __webpack_public_path__ + "img/logo-name.4bb90581.png";